<template>
  <InfuseDescriptionList :rows="rows" :item="item" :loading="loading">
    <template #ipRanges="{ data }">
      {{ mapIpRangeToString(data) || '-' }}
    </template>
  </InfuseDescriptionList>
</template>

<script lang="ts" setup>
import { InfuseDescriptionList } from '@infuse/ui/components';
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { NetworkProfile } from '@infuse/e-connector/network-profile/domain';
import { mapIpRangeToString } from '@infuse/e-connector/network-profile/utils';

interface Props {
  item: NetworkProfile;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  loading: false
});

const { t } = useI18n();

const rows: ComputedRef<UiDescriptionListRow[]> = computed(() => [
  {
    name: 'id',
    term: t('e_connector.common.networkProfile.id'),
    detailField: 'id'
  },
  {
    name: 'name',
    term: t('e_connector.common.networkProfile.name'),
    detailField: 'name'
  },
  {
    name: 'ipRanges',
    term: t('e_connector.common.networkProfile.ipRanges'),
    detailField: 'ipRanges'
  }
]);
</script>
